import { DomSanitizer } from '@angular/platform-browser';
import { LiquidacionCapturaFotografiasService } from './../../../services/liquidacion-captura-fotografias.service';
import { LiquidacionCapturaService } from './../../../services/liquidacion-captura.service';
import { ActivatedRoute, Router } from '@angular/router';
import { AutenticacionService } from '../../../services/autenticacion.service';
import { ValidatorService } from '../../../services/tools/validator.service';
import { Component, OnInit, ViewChild } from '@angular/core';
import { SuccessModalComponent } from '../../tools/modals/success-modal/success-modal.component';
import { ErrorModalComponent } from '../../tools/modals/error-modal/error-modal.component';
import { ConfirmModalComponent } from '../../tools/modals/confirm-modal/confirm-modal.component';
import {HelpersService} from "../../../services/tools/helpers.service";
import {WarningModalComponent} from "../../tools/modals/warning-modal/warning-modal.component";
declare var $;
declare var Dropzone;


@Component({
  selector: 'app-notas-fotografias',
  templateUrl: './notas-fotografias.component.html',
  styleUrls: ['./notas-fotografias.component.scss']
})
export class NotasFotografiasComponent implements OnInit {
  @ViewChild(SuccessModalComponent) successModal: SuccessModalComponent;
  @ViewChild(ErrorModalComponent) errorModal: ErrorModalComponent;
  @ViewChild(ConfirmModalComponent) confirmModal: ConfirmModalComponent;
  @ViewChild(WarningModalComponent) warningModal: WarningModalComponent;

  totales: any;
  searchText: string = "";
  mostrarListado: boolean = true;
  errors: any = {};
  searchProcess: any;
  paginate: any = {};
  fechaActual: string;
  fechaInicioLiquidacion: string;
  fechaFinLiquidacion: string;
  currentPage: any = 1;
  lastPage: any = 1;
  processing: any = false;
  alterTable: any = 'starting';
  exportingCSV: any = false;
  /* selected */
  liquidacionSelected: any = undefined;
  fotografiaSelected: any;
  fotografias: any[];
  conceptosSelectedOptions: any = [];
  cuentasSelectedOptions: any = [];
  proveedoresSelectedOptions: any = [];
  movimientosUrl: string;
  fondoUrl: string;
  defaultImage: string;

  //mostrar dato
  tipoMov : any;

  //CL
  private idLiquidacion:any;

  /* creator photo */
  public localFile: any = {};
  public savedFile: any;
  public dropzone;
  public uploading = false;
  public imageLoading: boolean;

  constructor(  private liquidacionCapturaFotografiasService: LiquidacionCapturaFotografiasService,
                private liquidacionCapturaService: LiquidacionCapturaService,
                private validatorService: ValidatorService,
                private helperService: HelpersService,
                private authService: AutenticacionService,
                private activedRoute: ActivatedRoute,
                private sanitizer: DomSanitizer,
                private router: Router) {
                  this.deleteFotografia = this.deleteFotografia.bind(this);
                  this.deleteLiquidacion = this.deleteLiquidacion.bind(this);
                  this.sendLiquidacion = this.sendLiquidacion.bind(this);
                  this.resetFotografiaSelected = this.resetFotografiaSelected.bind(this);
                }

  ngOnInit() {
    this.getIdLiquidacion();
  }

  getIdLiquidacion() {
    this.idLiquidacion = this.activedRoute.snapshot.params.id;
    this.movimientosUrl = '/liquidacion-captura/' + this.idLiquidacion + '/movimientos-obra';
    this.fondoUrl = '/liquidacion-captura/' + this.idLiquidacion +'/fondo-ahorro';
    if (this.idLiquidacion) {
      this.getLiquidacion();
    } else {
      console.log('dont found id liquidacion');
      this.regresar();
    }
  }

  getLiquidacion() {
    this.liquidacionCapturaService.getLiquidacionByID(this.idLiquidacion)
      .subscribe(response => {
        const content_response = response.json().content;
        this.liquidacionSelected = content_response;
        this.liquidacionSelected.fecha_formated = this.helperService.getMonthYearByDate(this.liquidacionSelected.fechaLiquidacion);
        this.start();
        console.log("dates",this.liquidacionSelected);
      }, error => {
        const content_error = error.json().content;
        // resuelve errores 403, 500 y sin internet
        this.helperService.httpGlobalError(error);

        if (error.status == 400 && content_error.id) {
          this.router.navigate(['/'])
        }
      });
  }

  getFechaActual() {
    this.liquidacionCapturaService.getFechaActual()
      .subscribe((response) => {
        const content = response.json().content;
        this.fechaActual = content.fecha;
        this.fechaInicioLiquidacion = content.fecha_inicio;
        this.fechaFinLiquidacion = content.fecha_fin;
      }, (error) => {
        // se revisan errores 403 - 500
        this.helperService.httpGlobalError(error);

        if (error == 400) {
          console.log('getFechasActual - error 400 ' , error);
        }
      });
  };

  start() {
    this.defaultImage = 'assets/images/bg-auth.jpg';
    this.goPage(1);
    this.getFechaActual();
    this.initDropzone();
  }

  regresar() {
    console.log('regresando a vista anterior');
    this.router.navigate(["/liquidacion-captura"]);
  }

  hasNotasRechazo() {
    return this.liquidacionSelected && this.liquidacionSelected.estado == 2 && this.liquidacionSelected.notasRechazo && this.canEdit();
  }

  hasMovimientos() {
    return this.liquidacionSelected && this.liquidacionSelected.movimientos > 0;
  }

  startFotografiaSelected() {
    this.resetFotografiaSelected();
    this.fotografiaSelected = this.liquidacionCapturaFotografiasService.getDefaultSchedule(this.fechaFinLiquidacion);
    this.fotografiaSelected.idLiquidacion = this.idLiquidacion;
    console.log('start fotografiaselected ', this.fotografiaSelected);
  }
  resetFotografiaSelected() {
    this.fotografiaSelected = undefined;
    this.localFile = {};
    this.uploading = false;
  }

  selectFotografia(fotografia) {
    this.resetFotografiaSelected();
    const fotografiaCloned = JSON.parse(JSON.stringify( fotografia ));
    this.fotografiaSelected = fotografiaCloned;
    this.fotografiaSelected.image_loaded = fotografia.image_loaded;
  }

  SelectedFotografiaClass(fotografias) {
    return (this.validatorService.required(this.fotografiaSelected) &&
        this.fotografiaSelected.idLiquidacion_Imagenes == fotografias.idLiquidacion_Imagenes) ? 'active' : '';
  }

  getFotografias(page = null) {
    this.liquidacionCapturaFotografiasService.getFotografias(this.idLiquidacion, page)
      .subscribe(response => {
        const content_response = response.json().content;
        this.fotografias = content_response;
        console.log("fotos",this.fotografias);
        this.alterTable = (this.fotografias.length > 0)? false: 'not_result';
        if (this.fotografias.length > 0) {
          this.loadFotografia(0);
        }
      }, error => {

      });
  }

  searchFotografias(page = null) {
    if (this.searchProcess){
      this.searchProcess.unsubscribe();
    }
    if (this.searchText.length > 1) {
      this.searchProcess = this.liquidacionCapturaFotografiasService.searchFotografias(this.idLiquidacion, this.searchText, page)
          .subscribe(response => {
            const content_response = response.json().content;
            this.fotografias = content_response;
            this.searchProcess = false;
            this.alterTable = (this.fotografias.length > 0)? false: 'not_found';
            if (this.fotografias.length > 0) {
          this.loadFotografia(0);
        }
          });
    } else {
      this.getFotografias(1);
      this.alterTable = 'starting';
    }
  }

  loadFotografia(posicion) {
    let fotografia = this.fotografias[posicion];
    if (fotografia.nombre) {
      fotografia.loading_foto = true;
      this.liquidacionCapturaFotografiasService.getFotografia(fotografia.idLiquidacion_Imagenes)
        .subscribe(response => {
          const unsave_url = window.URL.createObjectURL(response.blob());
          fotografia.image_loaded = this.sanitizer.bypassSecurityTrustUrl(unsave_url);
                    if (this.fotografiaSelected && this.fotografiaSelected.idLiquidacion_Imagenes == fotografia.idLiquidacion_Imagenes) {
            this.selectFotografia(fotografia);
            delete this.fotografiaSelected.loading_foto;
          } 
          delete fotografia.loading_foto;
        }, error => {
          delete fotografia.loading_foto;
        });

      if (this.fotografias.length -1  > posicion) {
        this.loadFotografia(posicion+1);
      }
    } else {
      if (this.fotografias.length -1  > posicion) {
          this.loadFotografia(posicion+1);
      }
    }
  }

  fotografiaSelectedWithId() {
    if (! this.fotografiaSelected) {
      return false;
    }

    return (this.fotografiaSelected.idLiquidacion_Imagenes);
  }

  createFotografia(){
    this.dropzone.options.url = this.liquidacionCapturaFotografiasService.service_url + '/imagen';
    this.uploadFotografia();
  }

  updateFotografia() {
    if (this.localFile.dataURL) {
      this.dropzone.options.url = this.liquidacionCapturaFotografiasService.getUpdateURL();
      this.uploadFotografia();
    } else {
      const fotografiaCloned = JSON.parse(JSON.stringify( this.fotografiaSelected ));
      delete fotografiaCloned.image_loaded;
      this.uploading = true;
      this.liquidacionCapturaFotografiasService.updateFotografia(fotografiaCloned)
        .subscribe(response => {
          this.helperService.notification('Imagen guardada', 'Se guardó correctamente la imagen de la liquidación.', 'success');
          this.goPage(this.currentPage);
          this.localFile = {};
          this.uploading = false;
        }, error => {
          console.log('update foto error ', error);
          this.helperService.httpGlobalError(error);
          this.localFile = {};
          this.uploading = false;
        });
    }
    
  }

  uploadFotografia() {
    this.errors = [];
    this.errors = this.liquidacionCapturaFotografiasService.validateFotografia(this.fotografiaSelected, this.localFile.dataURL);

    if (!this.errors['fechas'] && this.liquidacionCapturaFotografiasService.validateFotografiaDate(this.fotografiaSelected.fechas, this.fechaInicioLiquidacion, this.fechaFinLiquidacion)){
      this.errors['fechas'] = this.liquidacionCapturaFotografiasService.validateFotografiaDate(this.fotografiaSelected.fechas, this.fechaInicioLiquidacion, this.fechaFinLiquidacion);
    }
    if (!$.isEmptyObject(this.errors)) {
      return false;
    }
    this.uploading = true;
    this.dropzone.options.params.idLiquidacion_Imagenes = this.fotografiaSelected.idLiquidacion_Imagenes;
    this.dropzone.options.params.idLiquidacion = this.idLiquidacion;
    this.dropzone.options.params.fechas = this.fotografiaSelected.fechas;
    this.dropzone.options.params.notas = this.fotografiaSelected.notas;
    this.SelectedFotografiaClass(this.fotografiaSelected);
    this.dropzone.processQueue();
  }

  confirmSendLiquidacion() {
    this.confirmModal.open({
      'title': 'Liquidación',
      'description': 'Enviar a revisión <br/> ¿Desea enviar a revisión la Liquidación de ' + this.liquidacionSelected.obras.nombreObra +  ' del mes de ' + this.liquidacionSelected.fecha_formated + '?',
      'color': 'success',
      'text': 'Enviar',
      'callback': this.sendLiquidacion
    });
  }

  sendLiquidacion() {
    this.liquidacionCapturaService.sendLiquidacion(this.liquidacionSelected.idLiquidacion)
      .subscribe(response => {
        const content_response = response.json().content;
        this.helperService.notification('Liquidación Enviada', 'Se ha enviado a revisión la Liquidación de ' + this.liquidacionSelected.obras.nombreObra +  ' del mes de ' + this.liquidacionSelected.fecha_formated + '?', 'success');
        this.regresar()
      }, error => {
        console.log('error sendLiquidación ', error);
        this.helperService.httpGlobalError(error);
      })
  }

  confirmDeleteLiquidacion() {
    this.confirmModal.open({
      'title': 'Eliminar liquidación',
      'description': '¿Desea eliminar la liquidación ' + this.liquidacionSelected.obras.nombreObra +  ' del mes de ' + this.liquidacionSelected.fecha_formated + '?',
      'callback': this.deleteLiquidacion,
      'color': 'danger'
    });
  }
  deleteLiquidacion() {
    this.liquidacionCapturaService.deleteLiquidacion(this.idLiquidacion)
      .subscribe(response => {
        console.log('delete liq response ', response);
        this.helperService.notification('Liquidación eliminada', 'La liquidación ha sido eliminada.', 'success');
        this.regresar();
      }, error => {
        this.helperService.httpGlobalError(error);
      })
  }

  confirmDeleteFotografia(fotografia = null){
    if (fotografia) {
      this.selectFotografia(fotografia);
    }
    console.log('fotografia selected ', this.fotografiaSelected);
    this.confirmModal.open({
      'title': 'Eliminar fotografía',
      'description': '¿Desea eliminar la fotografía de la obra ' + this.liquidacionSelected.obras.nombreObra +  ' del mes de ' + this.liquidacionSelected.fecha_formated + '?',
      'callback': this.deleteFotografia,
      'color': 'danger'
    });
  }

  deleteFotografia() {
    this.liquidacionCapturaFotografiasService.deleteFotografia(this.fotografiaSelected.idLiquidacion_Imagenes)
      .subscribe(response => {
          this.processing = false;
          this.successModal.open({
            'title': 'Fotografía eliminada',
            'description': 'La fotografía de la obra ' + this.liquidacionSelected.obras.nombreObra +  ' del mes de ' + this.liquidacionSelected.fecha_formated + ' ha sido eliminada.'
          });
          this.goPage(this.currentPage);
          this.resetFotografiaSelected();
        }, error => {
          this.processing = false;
          
          // se resuelve los errores 403 y 500, no se requiere notification
          this.helperService.httpGlobalError(error, false);
  
          if (error.status == 400 || error.status == 500) {
            this.errorModal.open({
              'title': 'Error',
              'description': 'Ha ocurrido un error al intentar eliminar la fotografía, inténtelo más tarde'
            });
          }
      });
  }

  cancelarFotografiaSelected() {
    this.confirmModal.open({
      'title': 'Cancelar Cambios',
      'description': '¿Está seguro que desea cancelar estos cambios?',
      'callback': this.resetFotografiaSelected
    });
  }

  changeSwitchListado(){
    if(!this.mostrarListado){
      this.fotografiaSelected = this.liquidacionCapturaFotografiasService.getDefaultSchedule(this.fechaFinLiquidacion);
    }
  }

  getNotaCut(nota) {
    if (nota.length > 90) {
      return nota.slice(0, 90) + '...';
    }
    return nota
  }

  // CREATOR PHOTOS

  initDropzone() {
    let _this = this;
    // si no existe una sesión debemos matar el usuario y salir
    if (!this.authService.getToken()) {
      this.authService.killUser();
    }
    const token = this.authService.getToken();
    console.log('initDropzone-token ', token);
    console.log('dom', $('#creator-fotografia'));
    this.dropzone = new Dropzone('#creator-fotografia', {
      url: this.liquidacionCapturaFotografiasService.service_url + '/imagen',
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Cache-Control': '',
        'X-Requested-With': 'XMLHttpRequest',
        'Authorization': 'Bearer ' + token
      },
      paramName: 'imagen',
      params: {},
      acceptedFiles: 'image/jgp,image/jpeg,image/png',
      maxFilesize: 2,
      autoProcessQueue: false,
      init: function() {
        this.on('addedfile', function(file) {
          file.previewElement.remove();
          file.previewTemplate.remove();
          if (this.files.length > 1) {
            this.removeFile(this.files[0]);
          }
        });
        this.on('success', function(file, response) {
          const content_response = response.content;
          _this.helperService.notification('Imagen guardada', 'Se guardó correctamente la imagen de la liquidación.', 'success');
          _this.goPage(_this.currentPage);
          console.log('success response content ', content_response);
          _this.localFile = {};
          _this.uploading = false;
          if (content_response.id) {
            _this.fotografiaSelected.idLiquidacion_Imagenes = content_response.id;
          }
        });
        this.on('error', function(file, error) {
          _this.localFile = {};
          _this.uploading = false;
          if (file.size > 2000000) {
            console.log('sending');
            _this.helperService.notification('ERROR!', 'Tamaño máximo de imagen: 2MB.', 'error');
          } else {
            console.log('sending');
            _this.helperService.notification('ERROR!', 'Formato de imagen inválido.', 'error');
          }
        });
        this.on('thumbnail', function(file) {
          if (file.status != 'error') {
            _this.localFile = file;
          }
        });
      }
    });
  }

  // MODAL FUNCTIONS

  modalCallback(callback){
    callback();
  }

  // MAIN SECTIONS FUNCTIONS

  mainContainerClass(){
    return (this.mostrarListado)?"col-12":"offset-2 col-8";
  }

  mainTableClass(){
    return (this.mostrarListado)?"col-8":"col-4";
  }

  mainDetailsClass(){
    return (this.mostrarListado)?"col-4":"col-8";
  }

  startPaginate(content){
    this.paginate.first_item = content.from;
    this.paginate.last_item = content.to;
    this.paginate.last_page = content.last_page;
    this.paginate.per_page = content.per_page;
    this.paginate.total_items = content.total;
    this.paginate.current_page = content.current_page;
    this.currentPage = content.current_page;
    this.lastPage = content.last_page;

    this.paginate.pages = [];
    for (let i = 1; i <= this.paginate.last_page; i++) {
      this.paginate.pages.push({
        'number': i,
        'label': i
      });
    }
  }

  goPreviousPage(){
    this.goPage(this.paginate.current_page - 1);
  }

  goNextPage(){
    this.goPage(this.paginate.current_page + 1);
  }

  goPage(page) {
    if (this.searchText) {
      this.searchFotografias(page);
    } else {
      this.getFotografias(page);
    }
  }

  canEdit() {
    return (this.liquidacionSelected && this.liquidacionSelected.isDate && (this.liquidacionSelected.estado == 0 || this.liquidacionSelected.estado == 2));
  }

  writePermission() {
    return this.liquidacionCapturaService.writePermission();
  }

}



// WEBPACK FOOTER //
// ./src/app/components/liquidacion-captura/notas-fotografias/notas-fotografias.component.ts